import {Component, Input} from '@angular/core';
import {Q9TransformPipe} from '@q9elements/ui-kit/common';
import {IconDropdownComponent} from '@q9elements/ui-kit/components';
import {ITextJson} from 'src/app/diagram-data/diagram-json-handler.service';
import {getFontSizes} from 'src/app/shared/constants/fonts.constants';

@Component({
  standalone: true,
  imports: [IconDropdownComponent, Q9TransformPipe],
  template: `
    <q9-icon-dropdown [option]="option">
      <span class="font-size">{{ textJson.style.fontSize | transform: parseSize }}</span>
    </q9-icon-dropdown>
  `,
  styles: [
    `
      .font-size {
        font-size: 16px;
        min-width: 24px;
        color: var(--q9-primary-100-contrast);
        font-weight: 400;
        margin-right: 2px;
        line-height: 40px;
      }
    `
  ]
})
export class FontSizePickerComponent {
  @Input() textJson: ITextJson;
  @Input() changeFontSize: (value: string) => void;

  private readonly fontSizes = getFontSizes();

  public option = {
    icon: '',
    subOptions: this.fontSizes.map(size => {
      return {
        name: parseInt(size).toString(),
        action: () => this.changeFontSize(size)
      };
    })
  };

  public parseSize(size: string) {
    return parseInt(size);
  }
}
